<app-navigation-header
	title="Add Devices"
	i18n-title="@@addDeviceGroupName-addDevicesTitle"
	detail="{{ deviceGroupName }}"
	svgName="sl-add"
>
	<div class="add-devices-to-group-container small-stepper-circles">
		<!-- Add devices to group header container for current/future/past steps -->
		<div class="horizontal-stepper-label-container">
			<span>
				<app-access-horizontal-stepper-labels [steps]="steps" [currentStep]="currentStep">
				</app-access-horizontal-stepper-labels>
			</span>
			<span class="mat-stepper-navigator">
				@if (isHidden()) {
					<button
						class="secondary-small-button"
						i18n="@@addDeviceGroupMainTab-backButton"
						(click)="movePrevious()"
						data-automation-id="add-devices-to-group-back-button"
					>
						Back
					</button>
				}
				@if (isHidden()) {
					<button
						class="primary-small-button"
						[disabled]="!isValid()"
						(click)="moveNext()"
						data-automation-id="add-devices-to-group-continue-button"
						i18n="@@addDeviceGroupName-continueButton"
					>
						Continue
					</button>
				}
			</span>
		</div>

		@if (currentStep === 1) {
			<div>
				<app-add-device-group-confirmation
					[deviceGroupId]="deviceGroupId"
					[deviceGroupName]="deviceGroupName"
					[deviceCount]="count"
					[addDeviceGroupRequestStatusEvents]="addDeviceGroupRequestStatusEvents"
				>
				</app-add-device-group-confirmation>
			</div>
		}
	</div>

	@if (currentStep === 0) {
		<div>
			<app-add-device-group-devices
				[deviceDataRequest]="getAvailableDevices"
				[devicesLoadingKey]="availableDevicesLoadingKey"
				[editDeviceGroup]="editDeviceGroup"
				(devicesSelectedEvents)="addDevicesToGroup($event)"
			>
			</app-add-device-group-devices>
		</div>
	}
</app-navigation-header>
